<template>
  <div class="reference-input">
    <slot></slot>
    <div class="reference-input-tip"><kbd>Ctrl + Space</kbd> Insert variables</div>
    <button class="reference-input-toggle" @click="open"><span class="material-icons">auto_fix_high</span></button>
  </div>
</template>

<script>
import {inject} from "vue";

export default {
  name: 'ReferenceInputHelper',
  props: {
    single: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const node = inject('node');
    return {...props, node};
  },
  methods: {
    open() {
      this.$root.variableFinder.show(this.node, this.$el.querySelector('input, textarea, select'), this.single);
    }
  }
}
</script>
